import { TaskClosingCode } from '../types/interfaces';

export const TaskClosingCodesTemplate: TaskClosingCode = {
  id: 0,
  taskClosingCode: '',
  shortName: '',
  isDeleted: false
};
